export default __webpack_public_path__ + "static/media/video.66bffa76.svg";